import { Schema } from "effect";

export const MessageFacebookCommentState = Schema.Literal(
  "normal",
  "deleted",
  "hidden",
  "edited",
);
export type MessageFacebookCommentState =
  typeof MessageFacebookCommentState.Type;

export const MessageFacebookCommentAttribute = Schema.Literal(
  "has_been_replied_to",
  "liked",
);
export type MessageFacebookCommentAttribute =
  typeof MessageFacebookCommentAttribute.Type;
